var _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMale(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M25 50C38.8071 50 50 38.8071 50 25C50 11.1929 38.8071 0 25 0C11.1929 0 0 11.1929 0 25C0 38.8071 11.1929 50 25 50Z",
    fill: "url(#paint0_linear)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.0487 49.313C38.5646 49.313 49.5215 38.3562 49.5215 24.8403C49.5215 11.3243 38.5646 0.367477 25.0487 0.367477C11.5327 0.367477 0.575897 11.3243 0.575897 24.8403C0.575897 38.3562 11.5327 49.313 25.0487 49.313Z",
    fill: "#58698B",
    fillOpacity: 0.02
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.0717 49.4098C29.8536 49.4175 34.5321 48.0174 38.5237 45.384C37.6218 40.4556 34.1898 40.1748 34.1898 40.1748H15.2643C15.2643 40.1748 12.0258 40.4406 11.0143 44.9742C15.1296 47.869 20.0403 49.4184 25.0717 49.4098Z",
    fill: "#0899BA"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.8116 36.1368C31.3354 36.1368 36.6239 30.8483 36.6239 24.3245C36.6239 17.8007 31.3354 12.5122 24.8116 12.5122C18.2878 12.5122 12.9993 17.8007 12.9993 24.3245C12.9993 30.8483 18.2878 36.1368 24.8116 36.1368Z",
    fill: "#16679A"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M20.9993 34.1633H28.5681V40.2185C28.5681 41.2219 28.1696 42.1843 27.4602 42.894C26.7508 43.6036 25.7885 44.0025 24.7851 44.0029C23.7814 44.0029 22.8189 43.6042 22.1092 42.8945C21.3994 42.1848 21.0007 41.2222 21.0007 40.2185V34.1633H20.9993Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M21.2393 33.8825H28.331C28.3946 33.8825 28.4556 33.9078 28.5006 33.9528C28.5456 33.9978 28.5709 34.0588 28.5709 34.1225V39.9377C28.571 40.4348 28.4732 40.9271 28.2829 41.3864C28.0927 41.8458 27.8138 42.2631 27.4623 42.6146C27.1107 42.9661 26.6933 43.2449 26.2339 43.435C25.7746 43.6252 25.2823 43.7229 24.7851 43.7228C23.7814 43.7228 22.8189 43.324 22.1092 42.6143C21.3994 41.9046 21.0007 40.9421 21.0007 39.9384V34.1225C21.0007 34.0591 21.0258 33.9983 21.0705 33.9533C21.1152 33.9083 21.1759 33.8829 21.2393 33.8825Z",
    fill: "#FDB797"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M21.0129 37.0215C23.4522 37.9328 26.1373 37.9402 28.5816 37.0422V36.111H21.0129V37.0215Z",
    fill: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M24.8116 37.5279C30.8032 37.5279 35.6604 32.6707 35.6604 26.6791C35.6604 20.6874 30.8032 15.8302 24.8116 15.8302C18.8199 15.8302 13.9627 20.6874 13.9627 26.6791C13.9627 32.6707 18.8199 37.5279 24.8116 37.5279Z",
    fill: "#FDB797"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M17.0838 16.8109C17.0838 16.8109 21.6561 26.0917 34.5537 20.702L31.5508 15.9936L26.2278 14.0831L17.0838 16.8109Z",
    fill: "black"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0838 16.6748C17.0838 16.6748 21.6561 25.9556 34.5537 20.5645L31.5508 15.856L26.2278 13.9455L17.0838 16.6748Z",
    fill: "#16679A"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0437 16.0459C17.352 15.0915 17.8848 14.2251 18.5974 13.5194C20.7314 11.4098 24.23 10.9649 26.0244 8.55946C26.4542 9.22709 26.1218 10.2536 25.3797 10.5401C27.0989 10.5287 29.091 10.3782 30.0631 8.96419C30.3033 9.52345 30.3799 10.1394 30.2839 10.7405C30.1879 11.3415 29.9233 11.903 29.5208 12.3596C31.0444 12.4312 32.6727 13.4628 32.7686 14.985C32.8345 15.9993 32.1956 16.9592 31.3653 17.5408C30.5351 18.1225 29.5237 18.3897 28.5315 18.6082C25.6347 19.2479 15.1533 21.9248 17.0437 16.0459Z",
    fill: "#16679A"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9585 28.5616C14.5159 28.5616 14.9678 27.7143 14.9678 26.6691C14.9678 25.6238 14.5159 24.7765 13.9585 24.7765C13.401 24.7765 12.9492 25.6238 12.9492 26.6691C12.9492 27.7143 13.401 28.5616 13.9585 28.5616Z",
    fill: "#FDB797"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M35.659 28.5616C36.2164 28.5616 36.6683 27.7143 36.6683 26.6691C36.6683 25.6238 36.2164 24.7765 35.659 24.7765C35.1016 24.7765 34.6497 25.6238 34.6497 26.6691C34.6497 27.7143 35.1016 28.5616 35.659 28.5616Z",
    fill: "#FDB797"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 25,
    y1: 50,
    x2: 25,
    y2: 0,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#808080",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#808080",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#808080",
    stopOpacity: 0.1
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMale);
export default __webpack_public_path__ + "static/media/male.e371c4b684774bc805e0918ccf90dafe.svg";
export { ForwardRef as ReactComponent };